import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Card3 from "../Images/NewsFeeds/Agriculture/Agric1.jpg";
import Card1 from "../Images/NewsFeeds/Agriculture/Agric2.jpg";
import myVideo from "../Images/NewsFeeds/Agriculture/Agric3.mp4";

function AgriculturalOfficeLandscape() {
  return (
    <div className="art-page">
      <SEO
        title="Agricultural Thematic Area Changing the Office Landscape"
        description="CIRCODU's agricultural thematic area expanded research focus to agricultural development, combining clean energy and sustainable agriculture to improve livelihoods and environmental outcomes in rural communities."
        keywords="agricultural development, sustainable agriculture, clean energy, CIRCODU, thematic area, rural livelihoods, environmental outcomes, agricultural research, sustainable farming practices, clean energy solutions for agriculture, CIRCODU agricultural initiatives, agricultural thematic area Uganda, sustainable agriculture Uganda, clean energy agriculture Uganda, rural development Uganda, environmental sustainability agriculture Uganda"
        url="/Agricultural-Thematic-Area-Changing-the-Office-Landscape"
        image={Card1}
        datePublished="2024-02-22"
      />

      {/* ── Hero ──────────────────────────────────────── */}
      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Agricultural Thematic Area Changing the Office Landscape
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Article body ──────────────────────────────── */}
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              February 22, 2024
            </div>

            <h1 className="art-title">
              Agricultural Thematic Area Changing the Office Landscape
            </h1>

            <div className="texty">
              <p>
                At CIRCODU, research is never confined to the laboratory or the
                field alone — it lives and breathes right here in our own
                compound. Our Agricultural Thematic Area is proudly showcasing
                how small spaces and poor soils can be maximized to grow a rich
                variety of crops, right at the office.
              </p>
              <img
                src={Card1}
                alt="Agricultural Thematic Area Team Members planting crops"
                className="art-img"
              />
              <h2 className="art-subheading">From Decorative to Productive</h2>
              <p>
                In a bold and inspiring shift, our office has replaced most of
                its decorative plants with <strong>edible crops</strong>. What
                was once ornamental is now functional — a living demonstration
                that urban and peri-urban food production is not only possible
                but practical. The change is visible, tangible, and increasingly
                delicious.
              </p>
              <video
                width="100%"
                height="auto"
                controls
                style={{ borderRadius: "8px", marginBottom: "0.2rem" }}
              >
                <source src={myVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <h2 className="art-subheading">Turning Waste into Wealth</h2>
              <p>
                Using{" "}
                <strong>organic manure generated from kitchen waste</strong>{" "}
                produced right here in our office, we have amended the naturally
                infertile soils to improve their physical and chemical
                properties — enhancing structure, moisture retention, and
                nutrient availability to support healthy plant growth. This
                closed-loop approach transforms what would otherwise be
                discarded waste into a valuable soil amendment, reducing waste
                and production costs simultaneously.
              </p>
              <img
                src={Card3}
                alt="Agricultural Thematic Area Team Members tending to crops"
                className="art-img"
              />
              <h2 className="art-subheading">A Model Anyone Can Replicate</h2>
              <p>
                The beauty of this initiative is its simplicity and scalability.
                Any office or home can use internally generated organic waste to
                grow food in the available small spaces around them. No large
                farm. No expensive inputs. No specialist equipment. Just good
                practice, a little patience, and the willingness to look at
                "waste" differently.
              </p>
              <p>
                We hope this modest but meaningful demonstration inspires other
                organisations, households, and communities to explore the
                potential of the spaces and resources they already have. Food
                security starts small, and it can start right where you are.
              </p>
            </div>

            <div className="art-cta">
              <p>
                Interested in our agricultural research or community development
                programmes? Contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>

            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AgriculturalOfficeLandscape;
